import React, { useState } from 'react';

export default function FabButton({ onClick, ariaLabel = 'Action principale' }) {
  const [pressed, setPressed] = useState(false);

  const handleClick = (e) => {
    if ('vibrate' in navigator) navigator.vibrate(10);
    if (typeof onClick === 'function') onClick(e);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      onTouchStart={() => setPressed(true)}
      onTouchEnd={() => setPressed(false)}
      aria-label={ariaLabel}
      style={{
        ...styles.fab,
        transform: pressed ? 'scale(0.95)' : 'scale(1)',
      }}
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round">
        <path d="M12 5v14M5 12h14" />
      </svg>
    </button>
  );
}

const styles = {
  fab: {
    position: 'fixed',
    right: 16,
    bottom: 'calc(84px + env(safe-area-inset-bottom))',
    width: 56,
    height: 56,
    borderRadius: '50%',
    background: '#E8502A',
    border: 'none',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 6px 20px rgba(232, 80, 42, 0.4)',
    zIndex: 100,
    transition: 'transform 120ms ease',
    fontFamily: 'inherit',
  },
};
